import { Injectable, signal } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DropdownItem } from "@shared/models/dropdown-item.interface";

export interface ILanguageOption {
  code: string;
  label: string;
}

@Injectable({
  providedIn: "root",
})
export class TranslationService {
  private readonly STORAGE_KEY = "selected-language";

  readonly availableLanguages: ILanguageOption[] = [
    {
      code: "de",
      label: "Deutsch",
    },
    {
      code: "en",
      label: "English",
    },
  ];

  readonly currentLanguage = signal<ILanguageOption>(this.availableLanguages[0]);

  readonly dropdownItems: DropdownItem[] = this.availableLanguages.map((lang) => ({
    label: lang.label,
    value: lang.code,
  }));

  constructor(private translate: TranslateService) {
    translate.setDefaultLang("de");
  }

  initializeLanguage(): void {
    const savedLanguage = this.getSavedLanguage();
    const language = this.availableLanguages.find((lang) => lang.code === savedLanguage) || this.availableLanguages[0];
    this.setLanguage(language.code);
  }

  setLanguage(languageCode: string): void {
    const language = this.availableLanguages.find((lang) => lang.code === languageCode);
    if (language) {
      this.translate.use(languageCode);
      this.currentLanguage.set(language);
      this.saveLanguage(languageCode);
    }
  }

  private getSavedLanguage(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  private saveLanguage(languageCode: string): void {
    localStorage.setItem(this.STORAGE_KEY, languageCode);
  }
}
